import { createNode } from '@glueapp/graph-types';
import { GmailIntegration } from './GmailIntegration';

export const GMailSearchEmails = createNode({
    id: 'Gmail Search Emails',
    name: 'Gmail Search Emails',
    description: 'Get all the emails in your inbox',
    aiDescription:
        'Requires the Google Mail integration to be connected. Takes an optional "Search" (string) input port for filtering emails using Gmail search syntax. Unlike "Get Emails in Inbox", this searches across all labels, not just the inbox. Outputs an "Emails" port containing an array of objects with "id" and "threadId" properties.',
    category: 'Google Mail',
    color: '#ee4237',
    integration: GmailIntegration,
    inPorts: {
        Search: {
            kind: 'string',
        },
    },
    outPorts: {
        Emails: {
            kind: 'array',
            subType: {
                kind: 'object',
                properties: {
                    id: { kind: 'string' },
                    threadId: { kind: 'string' },
                },
                restriction: 'exact',
            },
        },
    },
    isAsync: true,
    execute: async function (input) {
        try {
            const searchQuery = input.inPorts.Search?.trim();
            let params = {
                ...(searchQuery ? { q: searchQuery } : {}),
                maxResults: 500,
            };
            const response = await input.integration.callIntegration<{ messages: { id: string; threadId: string }[] }>({
                url: 'https://gmail.googleapis.com/gmail/v1/users/me/messages',
                params,
            });
            return { output: { Emails: response.data.messages ?? [] } };
        } catch {
            return { output: { Emails: [] } };
        }
    },
});
